import React from "react";
import { FaCode, FaPaintbrush, FaGear, FaHeadset } from "react-icons/fa6";
import { Container, SectionHeading, IconTile, ArrowCircle } from "./ui";

const cards = [
  { icon: FaCode, tone: "blue", title: "Web Development", text: "Built Around Your Goals", href: "/service/website-design-development-solutions" },
  { icon: FaPaintbrush, tone: "pink", title: "UI/UX Design", text: "Experiences People Love", href: "/service/custom-website-design-development-solutions" },
  { icon: FaGear, tone: "green", title: "Custom Solutions", text: "Designed to Scale", href: "/software-development-services" },
  { icon: FaHeadset, tone: "orange", title: "Ongoing Support", text: "Here When You Need Us", href: "/contact-us" },
];

const OurServices = () => (
  <section id="services" className="relative overflow-hidden bg-white py-[72px] lg:py-[66px]">
    {/* <div className="bg-dots pointer-events-none absolute left-[5%] top-16 hidden h-24 w-36 opacity-70 lg:block" /> */}
    {/* <div className="bg-dots pointer-events-none absolute bottom-24 right-[4%] hidden h-24 w-36 opacity-70 lg:block" /> */}
    <Container className="relative">
      <SectionHeading
        badge="Our Services"
        title="Digital Solutions."
        highlight="Real Business Impact."
        highlightBreak={false}
        subtitle="We build modern web solutions that help businesses grow, engage users, and achieve measurable results."
        className="max-w-4xl"
      />
      <div className="mt-[48px] flex flex-wrap gap-6 max-w-6xl justify-center sm:mx-auto sm:gap-8 lg:mt-[64px] ">
        {cards.map((c) => (
          <a
            key={c.title}
            href={c.href}
            className="group rounded-3xl bg-white p-[28px] shadow-card ring-1 ring-slate-100 transition hover:-translate-y-1 hover:shadow-[0_20px_40px_-18px_rgba(30,64,175,0.3)]"
          >
            <IconTile icon={c.icon} tone={c.tone} size="lg" />
            <h3 className="mt-6 text-[20px] font-bold text-ink">{c.title}</h3>
            <p className="mt-1 text-[15px] text-slate-500">{c.text}</p>
            <ArrowCircle tone={c.tone} className="mt-6" />
          </a>
        ))}
      </div>
    </Container>
  </section>
);

export default OurServices;
